import states from 'constants/componentData/states';

const STATES = () => {
  const all = {};
  for (const country in states) {
    all[country] = states[country].reduce((items, state) => {
      items[state.value] = state.label;
      return items;
    }, {});
  }
  return all;
};

export default STATES();
